export const pillsTypes = {
  UNPOSTED_GL_JOURNALS: 'UNPOSTED_GL_JOURNALS',
  DECLINED_TAX_ENTRIES: 'DECLINED_TAX_ENTRIES',
  TAX_ENTRIES_PENDING_APPROVAL: 'TAX_ENTRIES_PENDING_APPROVAL',
  APPROVED_TAX_ENTRIES: 'APPROVED_TAX_ENTRIES',
};

export const pillsDefinition = [
  { label: 'Unposted GL Journals', type: pillsTypes.UNPOSTED_GL_JOURNALS },
  { label: 'Declined Tax Entries', type: pillsTypes.DECLINED_TAX_ENTRIES },
  { label: 'Tax Entries Pending Approval', type: pillsTypes.TAX_ENTRIES_PENDING_APPROVAL },
  { label: 'Approved Tax Entries', type: pillsTypes.APPROVED_TAX_ENTRIES },
];
